import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import Logo from '../components/Logo';

const InvitationSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <Logo size="medium" showCompanyName={true} />
        </div>
        <CheckCircleIcon className="h-16 w-16 text-green-600 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Registration Successful!</h1>
        <p className="text-gray-600 mb-4">
          Thank you for accepting the invitation!
        </p>
        <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-green-800 font-medium">
            ✅ Your ticket has been approved and sent to your email!
          </p>
          <p className="text-sm text-green-700 mt-2">
            Please check your inbox for your event ticket with QR code.
          </p>
        </div>
        <p className="text-sm text-gray-500 mb-8">
          Please save the email for entry to the event.
        </p>
        <button
          onClick={() => navigate('/')}
          className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Go to Homepage
        </button>
      </div>
    </div>
  );
};

export default InvitationSuccessPage;